/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component, Fragment } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter, Link } from "react-router-dom";
import axios from "axios";

import { toast } from "react-toastify"; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)

import NumberFormat from "react-number-format";

class FindPassword extends Component {
  state = {
    part: "email",
    userid: "",
    username: "",
    email: "",
    mobile: "",
    intReturn: 100,
    result: "N",
  };
  componentDidMount = () => {
    window.addEventListener("message", this.callbackCert);
  };
  componentWillUnmount = () => {
    window.removeEventListener("message", this.callbackCert);
  };
  callbackCert = (e) => {
    //console.log(e)
    if (e.data[0] === undefined || e.data[0] === null || e.data[0] === "") {
    } else {
      const callbackPart = e.data[0].callbackPart;

      if (callbackPart === "CERTPHONE") {
        //휴대폰 인증일 경우.. 결과값 받고 내부처리 루틴.
        //console.log(e.data)
        if (
          e.data[0].di === "" ||
          e.data[0].di === null ||
          e.data[0].di === undefined
        ) {
          toast.error("휴대폰 인증 값이 전달 되지 않았습니다.");
        } else {
          //
          this._onSendRealNameMobile(e.data[0].di);
        }
      } else if (callbackPart === "CERTIPIN") {
        //아이핀 인증일 경우.. 결과값 받고 내부처리 루틴.
        //console.log(e.data[0])
        if (
          e.data[0].encPsnlInfo === "" ||
          e.data[0].encPsnlInfo === null ||
          e.data[0].encPsnlInfo === undefined
        ) {
          toast.error("아이핀 정보 값을 전달 되지 않았습니다.");
        } else {
          this._onSendRealNameMobile(e.data[0].dupinfo);
        }
      }
    }
  };
  _onSendRealNameMobile = async (di) => {
    const { part } = this.state;
    const { onFindPwdCode } = this.props.childProps;

    const result = await this._onSendRealNameMobileApi(di);
    const intReturn = result.data[0].intReturn;
    const email = result.data[0].email;
    const mobile = result.data[0].mobile;

    //console.log('password....')
    //console.log(intReturn)
    if (part === "email") {
      onFindPwdCode(intReturn, email, 0);
    } else {
      onFindPwdCode(intReturn, mobile, 0);
    }

    if (intReturn === 0) {
      toast.success("임시 비밀번호 발송이 정상적으로 완료되었습니다. ");
    } else {
      toast.error("발송 오류.");
    }
  };
  _onSendRealNameMobileApi = (di) => {
    const { apiUrl } = this.props;
    const { part } = this.state;

    return axios
      .post(apiUrl + "/sendTempPwdReal", {
        params: {
          certPart: "mobile",
          part: part,
          di: di,
        },
      })

      .then((response) => response)
      .catch((error) => {
        toast.error("계정정보를 확인중 오류가 발생했습니다.");
      });
  };

  _onMobile = () => {
    const popupUrl =
      "https://www.aniplustv.com/aniplus2020Api/Join/join_2nd_1.asp";
    window.open(
      popupUrl,
      "certWindow",
      "width=450, height=600, resizable=0, scrollbars=no, status=0, titlebar=0, toolbar=0, left=435, top=250"
    );
  };
  _onIpin = () => {
    const popupUrl =
      "https://www.aniplustv.com/aniplus2020Api/Join/join_2nd_ipin_1.asp";
    window.open(
      popupUrl,
      "certWindow",
      "width=450, height=600, resizable=0, scrollbars=no, status=0, titlebar=0, toolbar=0, left=435, top=250"
    );
  };
  _onChangePart = (e) => {
    //console.log(e.target.value)
    this.setState({
      part: e.target.value,
    });
  };
  _onFind = async () => {
    const { part, username, email, mobile } = this.state;
    const { onFindPwdCode } = this.props.childProps;

    if (username === "" || username === null || username === undefined) {
      toast.warn("이름을 입력해 주세요.");
      return false;
    }
    if (part === "email") {
      if (email === "" || email === null || email === undefined) {
        toast.warn("가입시 등록한 email을 입력해 주세요.");
        return false;
      }
    }
    if (part === "mobile") {
      if (mobile === "" || mobile === null || mobile === undefined) {
        toast.warn("가입시 등록한 휴대폰 번호를 입력해 주세요.");
        return false;
      }
    }

    const result = await this._onFindApi();
    const intReturn = result.data[0].intReturn;
    // let findId;

    if (intReturn === 0) {
      //email. sms 발송 처리할 것...
      //alert(email + '로 발송')
      const sendResult = await this._onSendApi();
      // const intReturn = sendResult.data[0].intReturn;
      //console.log(sendResult)
      if (sendResult.data[0].intReturn === 0) {
        toast.success("임시 비밀번호 발송이 정상적으로 완료되었습니다. ");
      } else {
        toast.error("발송 오류.");
      }
    }

    if (part === "email") {
      onFindPwdCode(intReturn, email, 0);
    } else {
      onFindPwdCode(intReturn, mobile, 0);
    }
  };
  _onFindApi = () => {
    const { part, userid, username, email, mobile } = this.state;
    const { apiUrl } = this.props;

    ////console.log(part, username, email, mobile)
    ////console.log(apiUrl + '/findPwd?part=' + part + '&username=' + username + '&email=' + email)

    //return axios(apiUrl + '/findAcount?part=' + part + '&username=' + username + '&email=' + email)

    return axios
      .post(apiUrl + "/findPwd", {
        params: {
          part: part,
          userid: userid,
          username: username,
          email: email,
          mobile: mobile,
        },
      })

      .then((response) => response)
      .catch((error) => {
        toast.error("계정정보를 확인중 오류가 발생했습니다.");
      });
  };
  _onSendApi = () => {
    const { apiUrl } = this.props;
    const { userid, part } = this.state;

    return axios
      .post(apiUrl + "/sendTempPwd", {
        params: {
          part: part,
          userid: userid,
        },
      })

      .then((response) => response)
      .catch((error) => {
        toast.error("계정정보를 확인중 오류가 발생했습니다.");
      });
  };
  _onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };
  render() {
    const { part, userid, username, email, mobile } = this.state;
    // const { findPwdCode } = this.props.childProps;
    return (
      <Fragment>
        <div className="login_padding">
          <h1>
            <div>
              실명인증 또는 등록된 회원정보로 인증 후 가입시 등록된 이메일 또는
              휴대폰으로 임시 비밀번호를 재발급 받을 수 있습니다.
            </div>
          </h1>
          <div className="radio_btn" style={{ marginBottom: 10 }}>
            <div className="radio_group">
              <input
                id="radio1"
                type="radio"
                name="radio"
                value="email"
                checked={part === "email"}
                className="radiobox_img"
                onChange={this._onChangePart}
              />
              <label htmlFor="radio1">이메일주소</label>
            </div>
            <div className="radio_group">
              <input
                id="radio2"
                type="radio"
                name="radio"
                value="sms"
                checked={part === "sms"}
                className="radiobox_img"
                onChange={this._onChangePart}
              />
              <label htmlFor="radio2">문자메세지</label>
            </div>
          </div>
          <h1>1. 실명인증 후 발급받기</h1>
          <div className="yinzeng_btn">
            {/*
            <a style={{ cursor: "pointer" }} onClick={this._onIpin}>
              I-PIN
            </a>
            */}
            <a style={{ cursor: "pointer" }} onClick={this._onMobile}>
              본인인증
            </a>
            <div className="clear"></div>
          </div>
          {
            /* findPwdCode === 0 ? (*/
            <Fragment>
              <h1>2. 등록한 회원정보로 발급받기</h1>

              <ul className="radius1">
                <li className="">
                  <input
                    name="userid"
                    type="text"
                    className="common_input login_input"
                    value={userid}
                    onChange={this._onChange}
                    placeholder="아이디"
                  />
                </li>
                <li>
                  <input
                    name="username"
                    type="text"
                    className="common_input login_input"
                    value={username}
                    onChange={this._onChange}
                    placeholder="이름"
                  />
                </li>
                <li>
                  {part === "sms" ? (
                    <NumberFormat
                      name="mobile"
                      format="###-####-####"
                      value={mobile}
                      className="common_input login_input"
                      placeholder="휴대폰(-없이 숫자만)"
                      onChange={this._onChange}
                    />
                  ) : (
                    <input
                      name="email"
                      type="text"
                      className="common_input login_input"
                      value={email}
                      onChange={this._onChange}
                      placeholder="이메일"
                    />
                  )}
                </li>
              </ul>
              <div className="login_id">
                위의 2가지 방법으로 비밀번호 찾기가 불가능 하신가요?
                <br />
                <Link to="/customer/0">고객센터로</Link> 문의해 주세요.
                <br />
                TEL. 070-7162-7013
              </div>
              <div className="login_btn">
                <a style={{ cursor: "pointer" }} onClick={this._onFind}>
                  {part === "sms" ? "문자로 받기" : "이메일로 받기"}
                </a>
              </div>
            </Fragment>
            /*) : null */
          }
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(FindPassword));
